(function () {
  'use strict';

  function initReportedBy(root) {
    if (!root || root.getAttribute('data-reported-by-bound') === '1') return;
    root.setAttribute('data-reported-by-bound', '1');

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-rb-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-rb-panel]'));
    var bars = Array.prototype.slice.call(root.querySelectorAll('[data-rb-bar]'));
    if (!tabs.length || !panels.length) return;

    function activate(index) {
      var i;
      for (i = 0; i < tabs.length; i += 1) {
        var on = i === index;
        tabs[i].classList.toggle('is-active', on);
        tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
        tabs[i].tabIndex = on ? 0 : -1;
      }
      for (i = 0; i < panels.length; i += 1) {
        var show = i === index;
        panels[i].classList.toggle('is-active', show);
        if (show) {
          panels[i].removeAttribute('hidden');
        } else {
          panels[i].setAttribute('hidden', '');
        }
      }
      for (i = 0; i < bars.length; i += 1) {
        bars[i].classList.toggle('is-active', i === index);
        bars[i].setAttribute('aria-current', i === index ? 'true' : 'false');
      }
    }

    function indexFromControl(el) {
      var value = el.getAttribute('data-rb-index');
      var index = parseInt(value, 10);
      return isNaN(index) ? 0 : index;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(indexFromControl(tab));
      });
      tab.addEventListener('keydown', function (e) {
        var current = indexFromControl(tab);
        var next = current;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (current + 1) % tabs.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (current - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        else return;
        e.preventDefault();
        activate(next);
        tabs[next].focus();
      });
    });

    bars.forEach(function (bar) {
      bar.addEventListener('click', function () {
        activate(indexFromControl(bar));
      });
    });
  }

  function initAllReportedBy() {
    document.querySelectorAll('[data-reported-by]').forEach(initReportedBy);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllReportedBy);
  } else {
    initAllReportedBy();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelector) return;
    if (event.target.querySelector('[data-reported-by]')) initAllReportedBy();
  });
})();
